import React, { useEffect, useState } from 'react';

import CollapsableSection from '../../../../components/CollapsibleSection';
import ButtonForm from '../../../../components/ButtonForm';
import InputForm from '../../../../components/InputForm';
import WidgetHeaderStyleFields from '../../../../components/WidgetHeaderStyleFields';
import SelectableList from '../../../../components/SelectableList';
import SelectionForm from '../../../../components/SelectionForm';

import CheckIco from '../../../../components/icons/CheckIco';
import TrashIco from '../../../../components/icons/TrashIco';
import AddIco from '../../../../components/icons/AddIco';

import Spinner from '../../../../components/Spinner';
import { useAuth } from '../../../../providers/AuthContext';
import { useAppContext } from '../../../../providers/AppContext';
import { useNavigate } from 'react-router-dom';
import { useWidgets } from '../../../../providers/WidgetContext';
import { useDashboards } from '../../../../providers/DashboardContext';
import { createWidget, getWidgetById, updateWidget } from '../../../../services/apiWidgests';
import { getAllDevices } from '../../../../services/apiDevices';
import { getVariablesByDevice } from '../../../../services/apiVariables';

const ColumnField = ({ header, onDelete = () => {} }) => {
  return (
    <div className='flex justify-between items-center w-full mr-3'>
      <div className='flex basis-1/3 items-center gap-1'>
        <span>{header.alias || header.name}</span>
      </div>
      <span className='basis-1/3 text-gray-400'>{header.key}</span>
      <button className="" onClick={() => onDelete(header)}>
        <TrashIco fill='red' />
      </button>
    </div>
  );
};

// Configuración por defecto de un termómetro nuevo. min/max definen la
// escala del tubo (a qué altura se pinta el 0% y el 100% del relleno);
// fuera de ese rango el relleno se topa (clamp) en el extremo más cercano.
// La unidad NO se pide acá: se toma de la propia variable (campo
// "unity" configurado en Variables) si la tiene definida.
const DEFAULT_STYLE = { color: "#ef4444", min: 0, max: 100 };

function TelemetryThermometerForm({ onSubmit = () => {}, id }) {
  const { auth } = useAuth();
  const { addToast } = useAppContext();
  const navigate = useNavigate();

  const { addCard, assignSpace } = useWidgets();
  const { dashboard, selectedTab } = useDashboards();

  const [devicesList, setDevicesList] = useState({});
  const [selectedDevice, setSelectedDevice] = useState();
  const [variables, setVariables] = useState();
  const [title, setTitle] = useState('');
  const [validate, setValidate] = useState(false);
  const [conf, setConf] = useState();
  const [stage, setStage] = useState("form");

  const [fetchingVariables, setFechingVariables] = useState(true);
  const [creatingWidget, setCreatingWidget] = useState(false);
  const [fetchingWidgetInfo, setFetchingWidgetInfo] = useState(true);

  const refreshWidgetInfo = () => {
    async function fetchWidget() {
      const widget = await getWidgetById(id, auth?.token);
      return widget;
    }
    try {
      setFetchingWidgetInfo(true);
      fetchWidget().then(response => {
        setConf({
          ...response.configuration,
          style: { ...DEFAULT_STYLE, ...(response.configuration.style || {}) }
        });
        setFetchingWidgetInfo(false);
        setTitle(response.title);
      }).catch(error => {
        if (error.response?.status === 404) {
          console.log("Widget no encontrado");
        } else if (error.response?.status === 500) {
          console.log("Error en el servidor, intente nuevamente");
        } else {
          navigate('/logout');
        }
        setFetchingWidgetInfo(false);
      });
    } catch (error) {
      console.log(error, typeof (error));
      setFetchingWidgetInfo(false);
    }
  };

  const refreshDevices = () => {
    async function fetchDevices() {
      return await getAllDevices(auth?.token);
    }
    try {
      fetchDevices().then(response => {
        let tempDevices = {};
        response.map(infoDevice => tempDevices[infoDevice._id] = infoDevice.name || infoDevice.alias);
        setDevicesList({ ...tempDevices });
      }).catch(error => {
        if (error.response?.status === 404) {
          console.log("dispositivo no encontrado");
        } else if (error.response?.status === 500) {
          console.log("Error en el servidor, intente nuevamente");
        } else {
          navigate('/logout');
        }
      });
    } catch (error) {
      console.log(error, typeof (error));
    }
  };

  const refreshVariables = () => {
    async function fetchVariables() {
      return await getVariablesByDevice(selectedDevice, auth?.token);
    }
    try {
      setFechingVariables(true);
      fetchVariables().then(response => {
        setVariables(response.map(variable => ({
          name: variable.name,
          alias: variable.alias,
          _id: variable._id,
        })));
        setFechingVariables(false);
      }).catch(error => {
        if (error.response?.status === 404) {
          addToast("Dispositivo no encontrado", 3);
        } else if (error.response?.status === 500) {
          addToast("Error en el servidor, intente nuevamente", 2);
        } else if (error.response?.status === 419) {
          addToast("Sesión expirada", 1);
          navigate('/logout');
        } else {
          navigate('/logout');
        }
      });
    } catch (error) {
      console.log(error, "a", typeof (error));
      setFechingVariables(false);
    }
  };

  const createWidgetDB = () => {
    async function fetchWidget() {
      const position = assignSpace();
      return await createWidget({
        type: "telemetryThermometer",
        title: title,
        description: "",
        configuration: conf,
        dashboardId: dashboard._id,
        x: position.x,
        y: position.y,
        width: 160,
        height: 260,
        selectedTab
      }, auth?.token);
    }
    try {
      setCreatingWidget(true);
      fetchWidget().then(response => {
        addCard(response._id, response.title, response.type, response.dashboardId);
        onSubmit();
        setCreatingWidget(false);
        addToast("Widget " + title + " creado exitosamente.", 1);
      }).catch(error => {
        console.log(error);
        if (error.response?.status === 404) {
          addToast("Proceso no encontrado", 3);
        } else if (error.response?.status === 500) {
          addToast("Error en el servidor, intente nuevamente", 2);
        } else if (error.response?.status === 419) {
          addToast("Sesión expirada", 1);
          navigate('/logout');
        } else {
          navigate('/logout');
        }
      });
    } catch (error) {
      console.log(error, "a", typeof (error));
      setCreatingWidget(false);
    }
  };

  const editWidgetDB = () => {
    async function saveWidget() {
      return await updateWidget(id, {
        type: "telemetryThermometer",
        title: title,
        description: "",
        configuration: conf,
      }, auth?.token);
    }
    try {
      setCreatingWidget(true);
      saveWidget().then(() => {
        onSubmit();
        setCreatingWidget(false);
        addToast("Widget " + title + " editado exitosamente.", 1);
      }).catch(error => {
        console.log(error);
        if (error.response?.status === 404) {
          addToast("Proceso no encontrado", 3);
        } else if (error.response?.status === 500) {
          addToast("Error en el servidor, intente nuevamente", 2);
        } else if (error.response?.status === 419) {
          addToast("Sesión expirada", 1);
          navigate('/logout');
        } else {
          navigate('/logout');
        }
      });
    } catch (error) {
      console.log(error, "a", typeof (error));
      setCreatingWidget(false);
    }
  };

  const selectVariable = (selectedItems) => {
    if (variables && selectedItems) {
      const selectedV = variables.find(element => selectedItems.includes(element.alias || element.name));
      setConf(prev => ({ ...prev, variable: selectedV }));
    }
  };
  const deleteValue = () => {
    setConf(prev => ({ ...prev, variable: undefined }));
  };

  const handleDeviceChange = (deviceId) => {
    setConf(prev => ({
      ...prev,
      variable: undefined,
      device: { id: deviceId, name: devicesList[deviceId] }
    }));
  };
  const handleDecimalsChange = (decimals) => {
    setConf(prev => ({ ...prev, nDecimals: Number(decimals) }));
  };
  const handleStyleChange = (field, val) => {
    setConf(prev => ({ ...prev, style: { ...(prev.style || {}), [field]: val } }));
  };
  const handleCreateWidget = () => createWidgetDB();
  const handleEditWidget = () => editWidgetDB();

  useEffect(() => {
    if (selectedDevice) {
      refreshVariables();
      handleDeviceChange(selectedDevice);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDevice]);

  useEffect(() => {
    refreshDevices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setConf({
      device: undefined,
      variable: undefined,
      nDecimals: 1,
      style: { ...DEFAULT_STYLE }
    });
  }, []);

  useEffect(() => {
    if (id) {
      refreshWidgetInfo();
    }
    setFetchingWidgetInfo(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    const minMaxOk = conf?.style && Number(conf.style.min) < Number(conf.style.max);
    if (
      title === "" ||
      !conf?.device ||
      !conf?.variable ||
      conf?.nDecimals === undefined ||
      !minMaxOk
    ) {
      setValidate(false);
    } else {
      setValidate(true);
    }
  }, [conf, title]);

  return (
    <>
      {stage === "form" && (
        <>
          {conf && !fetchingWidgetInfo && (
            <div className='flex flex-col gap-2 h-[35rem] relative overflow-auto'>
              <div className='flex flex-col flex-grow gap-2'>
                <CollapsableSection title={"Datos"} titleBgColor='bg-lightblue' titleTextColor='text-bluesens' open={true} border={false}>
                  <div className='flex flex-col gap-2'>
                    <div className='flex justify-between items-center w-[50%] mb-1.5'>
                      <SelectionForm
                        text="Dispositivo"
                        options={Object.keys(devicesList)}
                        mask={devicesList}
                        value={selectedDevice}
                        onChange={event => setSelectedDevice(event)}
                        AppendClassName=' -mb-4'
                      />
                    </div>
                    <CollapsableSection
                      title={"Variable"}
                      titleBgColor='bg-aliceblue'
                      titleTextColor='text-gray'
                      open={true}
                    >
                      <div className='w-full flex flex-col px-4'>
                        {conf.variable && (
                          <ColumnField header={conf.variable} onDelete={deleteValue} />
                        )}
                        {!conf.variable && (
                          <div className=' mx-auto'>
                            <ButtonForm
                              text={"Agregar variable"}
                              Icon={() => (<AddIco fill='white' />)}
                              enabled={selectedDevice}
                              action={() => setStage("setVariable")}
                            />
                          </div>
                        )}
                      </div>
                    </CollapsableSection>
                  </div>
                </CollapsableSection>
                <CollapsableSection title={"Apariencia"} titleBgColor='bg-lightblue' titleTextColor='text-bluesens' border={false} open={true}>
                  <div className='-mb-4'>
                    <InputForm text={"Nombre"} value={title} onChange={(event) => setTitle(event.target.value)} />
                  </div>
                  <div className='-mb-4 pt-2'>
                    <InputForm type={"number"} text={"Decimales"} value={conf.nDecimals} onChange={(event) => handleDecimalsChange(event.target.value)} />
                  </div>
                  <div className='pt-4'>
                    <CollapsableSection title={"Escala y color"} titleBgColor='bg-aliceblue' titleTextColor='text-gray' open={true}>
                      <div className='flex flex-col gap-2 px-2 pb-2'>
                        <div className='flex items-end gap-3'>
                          <div className='w-1/2'>
                            <InputForm
                              type="number"
                              id="min"
                              text="Mínimo"
                              value={conf.style?.min}
                              onChange={(e) => handleStyleChange('min', Number(e.target.value))}
                            />
                          </div>
                          <div className='w-1/2'>
                            <InputForm
                              type="number"
                              id="max"
                              text="Máximo"
                              value={conf.style?.max}
                              onChange={(e) => handleStyleChange('max', Number(e.target.value))}
                            />
                          </div>
                        </div>
                        <div className='w-1/2'>
                          <InputForm
                            type="color"
                            id="thermColor"
                            text="Color del termómetro"
                            value={conf.style?.color}
                            onChange={(val) => handleStyleChange('color', val)}
                          />
                        </div>
                        {conf.style && Number(conf.style.min) >= Number(conf.style.max) && (
                          <span className='text-sm text-red_error -mt-3'>El mínimo debe ser menor que el máximo</span>
                        )}
                      </div>
                    </CollapsableSection>
                  </div>
                  <div className='pt-2'>
                    <WidgetHeaderStyleFields
                      headerColor={conf?.headerColor}
                      headerTextColor={conf?.headerTextColor}
                      onChange={(field, val) => setConf(prev => ({ ...prev, [field]: val }))}
                    />
                  </div>
                </CollapsableSection>
              </div>

              <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
                <div className='flex w-full justify-end'>
                  <button className='' onClick={() => id ? handleEditWidget() : handleCreateWidget()} disabled={!validate}>
                    <CheckIco width='50px' height='50px' fill={validate ? 'bluesens' : 'gray'} />
                  </button>
                </div>
              </div>
            </div>
          )}
          {(!conf || fetchingWidgetInfo) && (
            <Spinner />
          )}
        </>
      )}
      {stage === "setVariable" && (
        <div className='flex flex-col gap-2 h-[25rem] relative overflow-auto '>
          <div className='flex flex-col flex-grow gap-2'>
            <span className='font-semibold text-lg'>{"Seleccione variable"}</span>
            <SelectableList
              items={variables.map(element => element.alias ? element.alias : element.name)}
              multiSelect={false}
              setItems={selectVariable} />
          </div>
          <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
            <div className='flex w-full justify-end'>
              <ButtonForm text={"Guardar"} enabled={true} action={() => setStage('form')} />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default TelemetryThermometerForm;
